import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\src\\app\\beer-bottle\\page.tsx");
